export const SalesStatus = {
  Ongoing: "F",
  Discontinued: "A",
} as const;

export type SalesStatus = (typeof SalesStatus)[keyof typeof SalesStatus];

export function processSalesStatus(value: string | undefined | null): SalesStatus {
  if (!value) {
    return SalesStatus.Ongoing;
  }

  value = value.toUpperCase();
  if (value === "A" || value === "F") {
    return value;
  }
  // "L" is also discontinued
  if (value === "L") {
    return SalesStatus.Discontinued;
  }

  if (import.meta.env.DEV) {
    console.warn(`Unknown sales status: ${value}`);
  }
  return SalesStatus.Ongoing;
}
